import React from "react";
import { NavLink } from "react-router-dom";
import rightArrow from "../../../assets/images/right-arrow.svg";
import shape from "../../../assets/images/shape.svg";
import backpain from "../../../assets/images/backpain.png";
import stethoscope from "../../../assets/images/stethoscope.svg";

const Hero = () => {
  return (
    <section className="home flex py-[20px]  item-center overflow-hidden  relative">
      <img
        src={shape}
        alt=""
        className="absolute w-[7.729vw] h-[8.063vw]  right-[5%] top-[8%] "
      />
      <img
        src={shape}
        alt=""
        className="absolute  left-[1%] bottom-[3%] w-[7.729vw] h-[8.063vw] "
      />
     
      <img
        src={backpain}
        alt=""
        className="absolute backpain_img w-[20.438vw] h-[15.646vw]  right-[5%] bottom-[5%] "
      />
      <img
        src={stethoscope}
        alt=""
        className="absolute w-[8.802vw] h-[8.802vw]  left-[53%] bottom-[0%] "
      />

      <div className="container  h-hull  relative  ">
        <div className="content home-content max-w-[1200px] w-full md:gap-[27px] gap-[15px]  pb-[10px]">
          <h1>
            Suffering from chronic{" "}
            <span className="text-[#FFD162] ">back pain?</span>{" "}
          </h1>
          <p className="text-[17px] text-white font-[400] max-w-[1061px] w-full ">
            Understand your risk of having Axial Spondyloarthritis by taking a
            quick survey. Early diagnosis matters.
          </p>
          <p className="text-[17px] text-white font-[400] max-w-[1061px] w-full  ">
            Axial Spondyloarthritis (axSpA), also called Ankylosing Spondylitis
            is inflammatory disease of the spine and sacroiliac joints that
            leads to chronic back or hip pain. A-Tool&copy; is a survey designed
            to assess your risk of having axSpA and guide you if you should seek
            medical advice.
          </p>

          <p className="!text-[17px] !text-[#FFD162] !font-[700] max-w-[800px] w-full ">
            Please complete this survey if you have had back or hip pain for
            longer than three months AND it began before the age of 45 years.
          </p>
          <NavLink to="/survey" className="pain_survey_btn">
            Take A-Tool&copy; Back Pain survey
            <div className="arrow_icon flex justify-center items-center ">
              <img src={rightArrow} className="w-[30px] "  alt="" />
            </div>
          </NavLink>
          <p className="text-[17px] text-white font-[400] max-w-[1061px] w-full  ">
            The A-Tool&copy; can be completed by patient or administered by
            healthcare provider.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
